import HBIcon from "@/components/HBIcon";
import HBSwiper from "@/components/HBSwiper";
import { TrackerA } from "@/components/Tracker";
import { getTopicPins } from "@/services";
import { Skeleton } from "antd";
import Schedule from "pageComponents/Calendars/Schedule";
import { useCallback, useEffect, useMemo, useState } from "react";
import Cover from "./cover";
import styles from "./index.module.less";

export default function MaterialCalendar({
  data,
  calendarsList,
  serverResult,
  className,
  isSmall,
}) {
  const [activeFestival, setActiveFestival] = useState(
    calendarsList?.[0]?.code
  );
  const [dataSource, setDataSource] = useState({
    [`${activeFestival}`]: serverResult,
  });

  // const [imgType, setImgType] = useState(pinType.long);
  const [loading, setLoading] = useState(false);
  const getPinList = useCallback(
    async (flatFiltersArr) => {
      setLoading(true);
      // 避免其中一个报错影响其他展示

      let result = await Promise.allSettled(
        flatFiltersArr.map((item) => {
          return getTopicPins({
            filter_ids: [item.id],
            sort: "all",
            page: 1,
            per_page: 4,
            position: "topics",
            text: "",
          });
        })
      );

      let fulfilledResults = [];
      result.forEach((res, index) => {
        if (res.status === "fulfilled") {
          let data = {
            ...res.value,
            filter: flatFiltersArr[index],
          };
          fulfilledResults.push(data);
        }
      });

      setDataSource((dataSource) => {
        return {
          ...dataSource,
          [`${activeFestival}`]: fulfilledResults,
        };
      });

      setLoading(false);
    },
    [activeFestival]
  );

  const currentFestival = useMemo(() => {
    let currentFestival = calendarsList?.find(
      (item) => item.code === activeFestival
    );

    return { ...currentFestival };
  }, [calendarsList, activeFestival]);

  useEffect(() => {
    // dataSource
    if (currentFestival?.filters && !dataSource[`${activeFestival}`]) {
      getPinList(currentFestival?.filters);
    }
  }, [currentFestival?.filters, activeFestival, dataSource, getPinList]);

  const clickCard = (festivalInfo) => {
    setActiveFestival(festivalInfo.code);
  };

  if (!calendarsList?.length) {
    return null;
  }

  return (
    <div className={className}>
      <div className={styles.header}>
        <div className={styles.title}>{data.name}</div>
        <div className={styles.more}>
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <TrackerA
            href={`/calendars/${activeFestival}`}
            target="_blank"
            rel="noopener"
            data-gd-click="button_click"
            data-content-source="热点日历"
            data-button-name="热点日历-查看更多"
          >
            更多热点日历
            <HBIcon type="ic_chevron_right" />
          </TrackerA>
        </div>
      </div>

      <Schedule
        calendarsList={calendarsList}
        festival={activeFestival}
        clickCard={clickCard}
      ></Schedule>
      {loading ? (
        <div className={styles.loadingContent}>
          <div className={styles.loadingContent}>
            {new Array(isSmall ? 4 : 5).fill("").map((item, index) => {
              return (
                <Skeleton.Input
                  active
                  className={styles.skeletonCard}
                  key={index}
                ></Skeleton.Input>
              );
            })}
          </div>
        </div>
      ) : (
        <HBSwiper
          className={styles.swiper}
          iconClassName={styles.icon}
          padding={10}
        >
          <div className={styles.list}>
            {dataSource[`${activeFestival}`]?.map((item, index) => {
              const { pins, pin_count, filter } = item;
              if (!filter) return null;
              return (
                <Cover
                  pinCount={pin_count}
                  pins={pins}
                  key={index}
                  filter={filter}
                  activeFestival={activeFestival}
                  data-gd-expose="topic_expose"
                  data-gd-click="topic_click"
                  data-topic-id={filter.id}
                  data-topic-type="二级主题"
                  data-topic-title={filter.name}
                  data-content-source={`热点日历_${
                    calendarsList?.find((i) => i.code === activeFestival)?.title
                  }_${filter.name}`}
                ></Cover>
              );
            })}
          </div>
        </HBSwiper>
      )}
    </div>
  );
}
